<template>
    <ul class="pagination pagination-sm no-margin pull-left">
      <li>
        <span>
          {{ 'result_per_side' | translate }}
        </span>
      </li>
      <li class="paginate_button previous">
        <button
          :disabled="perPage === 25"
          :class="[perPage === 25 ? 'active' : '', 'paginate_button', 'page-link']"
          @click.prevent="changePage(25)">
          25
        </button>
      </li>
      <li class="paginate_button previous">
        <button
          :disabled="perPage === 50"
          :class="[perPage === 50 ? 'active' : '', 'paginate_button', 'page-link']"
          @click.prevent="changePage(50)">
          50
        </button>
      </li>
      <li class="paginate_button previous">
        <button
          :disabled="perPage === 100"
          :class="[perPage === 100 ? 'active' : '', 'paginate_button', 'page-link']"
          @click.prevent="changePage(100)">
          100
        </button>
      </li>
      <li class="paginate_button previous">
        <button
          :disabled="perPage === 200"
          :class="[perPage === 200 ? 'active' : '', 'paginate_button', 'page-link']"
          @click.prevent="changePage(200)">
          200
        </button>
      </li>
    </ul>
</template>
<script>
import ProductStatistics from "../views/Statistics/ProductStatistics";

export default {
  components: {
    ProductStatistics
  },
  data() {
    return {
      perPage: 25
    }
  },
  methods: {
    changePage: function (perPage) {
      this.perPage = perPage
      this.$emit('page-changed', this.perPage)
      //
    },
  }
}
</script>
<style>

</style>



// WEBPACK FOOTER //
// src/components/tools/ResultPerSideBar.vue